/* OO(2026-10-08) 追加の直し
   10) 絞り込みの引き出し（下のボタンが固定バーに隠れる・英語が残る）
   11) いちばん上のお知らせの帯を「1文ずつ切り替え」に
*/
(function () {
  'use strict';

  /* 10) 引き出しが開いているあいだ、body に印をつける（CSSで下のバーを隠す） */
  function watchFilters() {
    var dr = document.querySelector('details[id^="Filters-drawer"]');
    if (!dr || dr.getAttribute('data-oo-watch')) return;
    dr.setAttribute('data-oo-watch', '1');
    var sync = function () {
      document.body.classList.toggle('oo-filters-open', !!dr.open);
    };
    dr.addEventListener('toggle', sync);
    // クラスの付け外しでも開閉するので、少しの間は見張る
    var n = 0;
    var t = setInterval(function () {
      sync();
      n += 1;
      if (n >= 40) clearInterval(t);
    }, 400);
    sync();
  }

  /* 10) 引き出しの中の英語を日本語に */
  var WORDS = [
    ['Filter by', '絞り込み'],
    ['Clear all', 'すべてクリア'],
    ['Clear All', 'すべてクリア'],
    ['Apply', '適用'],
    ['Availability', '出品状況'],
    ['Price', '価格']
  ];
  function jaFilters() {
    var box = document.querySelector('details[id^="Filters-drawer"]');
    if (!box) return;
    box.querySelectorAll('h1,h2,h3,h4,h5,span,a,button,legend,summary').forEach(function (e) {
      if (e.children.length) return;
      var t = (e.textContent || '').trim();
      for (var i = 0; i < WORDS.length; i += 1) {
        if (t.toLowerCase() === WORDS[i][0].toLowerCase()) {
          e.textContent = WORDS[i][1];
          return;
        }
      }
    });
  }

  /* 11) お知らせの帯を1文ずつ切り替える */
  var annTimer = null;
  function announceSwitch() {
    var bar = document.querySelector('.announcement_bar__marquee');
    if (!bar || bar.getAttribute('data-oo-switch')) return;
    var lists = bar.querySelectorAll('.marquee__content');
    if (!lists.length) return;

    // 2つめ以降は、流すために複製されたもの。使わない
    for (var i = 1; i < lists.length; i += 1) lists[i].classList.add('oo-dup');

    var items = Array.prototype.slice.call(lists[0].children);
    var seen = {};
    var uniq = [];
    items.forEach(function (li) {
      var t = (li.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t) { li.classList.add('oo-hide'); return; }
      if (seen[t]) { li.classList.add('oo-hide'); return; }
      seen[t] = 1;
      uniq.push(li);
    });
    if (uniq.length < 2) return;

    bar.setAttribute('data-oo-switch', '1');
    document.body.classList.add('oo-announce-switch');

    var idx = 0;
    uniq[0].classList.add('oo-on');
    if (annTimer) clearInterval(annTimer);
    annTimer = setInterval(function () {
      uniq[idx].classList.remove('oo-on');
      idx = (idx + 1) % uniq.length;
      uniq[idx].classList.add('oo-on');
    }, 4000);
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    watchFilters();
    jaFilters();
    announceSwitch();
    var n = 0;
    var t = setInterval(function () {
      watchFilters();
      jaFilters();
      announceSwitch();
      n += 1;
      if (n >= 12) clearInterval(t);
    }, 600);
  });
})();